import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { Box, Typography, Stack, Collapse } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { getOrganizationsByParentIds } from '@app/adapter/organization-service';
import { CarouselProduct } from '@app/components/Company/CarouselProduct';
import { getProducts } from '@app/domain/network-actions';
import { CategoryType, Product } from '@app/types/catalog';

interface ShowroomListProps {
  organizationId: string;
}

export function ShowroomList({ organizationId }: ShowroomListProps) {
  const [showrooms, setShowrooms] = useState<Product[]>([]);
  const [isExpanded, setIsExpanded] = useState(false);
  const location = useLocation();

  const fetchProducts = useCallback(async () => {
    try {
      // 企業に紐づく子Organization(窓口)を取得
      const organizationResponse = await getOrganizationsByParentIds([
        organizationId,
      ]);
      const childOrganizationIds = organizationResponse.data.value.map(
        (org: { id: string }) => org.id
      );

      if (childOrganizationIds.length === 0) {
        return;
      }
      const params = new URLSearchParams(location.search);
      const attributeIds = params.get('attributes')?.split(',') || [];

      const options = {
        attributeIds,
        category: CategoryType.EXHIBITION,
        childrenIds: childOrganizationIds,
        expand: 'organization',
        limit: 20,
      };

      const response = await getProducts(options);
      setShowrooms(response.data.value);
    } catch (error) {
      console.error('Failed to fetch organization products', error);
    }
  }, [location.search, organizationId]);

  useEffect(() => {
    void fetchProducts();
  }, [fetchProducts]);

  if (showrooms.length === 0) {
    return null;
  }

  return (
    <Box width="100%">
      <Stack
        alignItems="center"
        borderRadius={10}
        bgcolor="#3287e1"
        direction="row"
        px={1}
        height={32}
        spacing={1}
        justifyContent="space-between"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <Typography
          variant="body1"
          sx={{
            color: 'white',
            fontWeight: 'bold',
            px: 2,
            textAlign: 'left',
          }}
        >
          住宅展示場一覧
        </Typography>
        <ExpandLessIcon
          role="button"
          sx={{
            color: 'white',
            transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: '0.3s',
          }}
        />
      </Stack>
      <Collapse in={isExpanded} sx={{ mt: 2 }}>
        <CarouselProduct
          products={showrooms}
          sx={{ width: 170 }}
          options={{
            autoWidth: true,
            classes: {
              page: 'splide__pagination__page custom-dot',
              pagination: 'splide__pagination',
            },
            gap: 10,
            pagination: true,
            perPage: 4,
            rewind: true,
          }}
        />
      </Collapse>
    </Box>
  );
}
